export default "__VITE_ASSET__HhjLu1mS__"